import React from 'react';

import { closePopup, getPopupRegistration, openPopup, Priority } from 'app/PopupHolder';
import SimpleModal from 'components/base/SimpleModal';

import css from './style.scss';

// "Unlock Investor Outreach" confirmation — Figma 1376:152690 (Confirmation Dialog Box).
//
// Step two of the trial holder's Unlock Now flow (ATAI-260 / S7): the upsell overlay sells the
// feature, this asks them to confirm converting the trial, and only then does the shared Activate
// Subscription modal take the payment. Non-trial holders never see it — they go straight to the
// S8 purchase page.
//
// Opened at HIGHEST so it stacks ON TOP of the upsell overlay instead of queueing invisibly
// behind it: this app's popup priorities are separate layers and same-priority popups are FIFO
// (see Profile/EditContactModal's note). That is also what makes Cancel free — closing this
// dialog leaves the upsell showing underneath, with nothing to re-open.
const UnlockConfirmModal = (props) => {
  const { onCancel, onConfirm } = props;

  const dismiss = (next) => {
    props.closePopup && props.closePopup();
    next && next();
  };

  return (
    <SimpleModal
      isOpen
      uniqueId="InvestorOutreachUnlockConfirm"
      title="Unlock Investor Outreach"
      description="To access Investor Outreach, convert your PropStream trial to a paid subscription today."
      cancelText="Cancel"
      submitText="Unlock"
      // Esc / outside-click land on onCancel too, which is the same harmless outcome as the
      // Cancel button: back to the upsell.
      onCancel={() => dismiss(onCancel)}
      onSubmit={() => dismiss(onConfirm)}
      modalClassName={css.clsDialog}
      modalTitleClassName={css.clsTitle}
      modalDescriptionClassName={css.clsDescription}
      modalFooterWrapperClassName={css.clsFooter}
      modalCancelBtnClassName={css.clsCancelBtn}
      modalSubmitBtnClassName={css.clsUnlockBtn}
    />
  );
};

const registrationId = getPopupRegistration(UnlockConfirmModal);
UnlockConfirmModal.open = (props = {}) =>
  openPopup(registrationId, { ...props, priority: Priority.HIGHEST });
UnlockConfirmModal.close = () => closePopup({ popup: registrationId });

export default UnlockConfirmModal;
